import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=70b2d7aa&scoped=true&"
import script from "./MyOrders.vue?vue&type=script&lang=ts&"
export * from "./MyOrders.vue?vue&type=script&lang=ts&"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=70b2d7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2d7aa",
  null
  
)

export default component.exports